import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShopCart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "shop_cart",
	"data-name": "shop cart",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "cart",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				className: "plan2plate-icon",
				cx: 10.07,
				cy: 20.59,
				r: 1.91
			}),
			/* @__PURE__ */ _jsx("circle", {
				className: "plan2plate-icon",
				cx: 18.66,
				cy: 20.59,
				r: 1.91
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "plan2plate-icon",
				d: "M.52,1.5H3.18a2.87,2.87,0,0,1,2.74,2L9.11,13.91H8.64A2.39,2.39,0,0,0,6.25,16.3h0a2.39,2.39,0,0,0,2.39,2.38h10"
			}),
			/* @__PURE__ */ _jsx("polyline", {
				className: "plan2plate-icon",
				points: "7.21 5.32 22.48 5.32 22.48 7.23 20.57 13.91 9.11 13.91"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgShopCart);
export default ForwardRef;
